<script>
  export let altText = "";
  export let svgPath = "";
  export let color = "#ff5f1f";
  export let disabled = false;
</script>

<button
  class="icon_button_wrapper"
  style="background-color:{disabled ? 'grey' : color}; cursor: {disabled
    ? 'default'
    : 'pointer'}"
  {disabled}
  on:click
>
  <div class="img_wrapper">
    <img
      src={svgPath}
      alt={altText}
      aria-hidden="true"
      width="20"
      height="20"
    />
  </div>
</button>

<style>
  .icon_button_wrapper {
    padding: 0.5rem;
    border-radius: 5rem;
    color: white;
    transition: 300ms;
    border: none;
  }
  .icon_button_wrapper:hover {
    background-color: #1c1c20;
  }
  .img_wrapper {
    height: 20px;
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  img {
    color: white;
  }
</style>
